import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "mb-2 field required" }
const _hoisted_3 = { class: "mb-2 field required" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4 flex"
}
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = { class: "remove-notice mb-2" }
const _hoisted_7 = { class: "remove-notice" }

import { toRefs, ref, watchEffect } from 'vue';
import Calendar from 'primevue/calendar';
import { useOrganizationContractsStore } from '@/store';
import { useDateTime } from '@/composables';
import { DisciplineInterface } from '@/types';
import { EMIT } from '@/enum';

interface PropsInterface {
  discipline: DisciplineInterface;
}

// the ConfirmAction emit already has the cancel emit attached to it,
// so cancel is getting called twice, causing errors in the parent.

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractRemoveDisciplineModal',
  props: {
    discipline: {}
  },
  setup(__props: any, { emit: __emit }) {

const removeCancelEmit = `${EMIT.REMOVE}-${EMIT.CANCEL}`;
const emit = __emit;
const props = __props;
const { discipline } = toRefs(props);
const contractStore = useOrganizationContractsStore();
const endDate = ref<Date>();
const serviceEndDate = ref<Date>();
const eventsRemoved = ref<number>(0);
const serviceProvidersCount = ref<number>(0);

const onCancel = () => emit(removeCancelEmit);

const onRemove = () =>
  emit(EMIT.REMOVE, {
    schedule_by_date: useDateTime().formatDateForApi(endDate.value),
    document_by_date: useDateTime().formatDateForApi(serviceEndDate.value),
  });

watchEffect(async () => {
  if (endDate.value) {
    const { events_count, service_provider_count } = await contractStore.checkEventToRemove({
      discipline_id: discipline.value.discipline_id,
      start_at: useDateTime().formatDateForApi(contractStore.contract.start_at),
      end_at: useDateTime().formatDateForApi(endDate.value),
    });
    eventsRemoved.value = events_count;
    serviceProvidersCount.value = service_provider_count;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createBlock(_component_ConfirmAction, {
    header: "Remove Discipline",
    class: "remove-discipline-modal",
    style: { width: '30rem' },
    "content-class": "pb-0",
    "show-footer": true,
    "accept-label": "Remove Discipline",
    onAccept: onRemove,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "end_date" }, [
            _createTextVNode(" End Date "),
            _createElementVNode("span", { class: "sub-text" }, "(no new events of this discipline after:)")
          ], -1)),
          _createVNode(_unref(Calendar), {
            id: "end_date",
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((endDate).value = $event)),
            class: "w-full",
            placeholder: "01/01/2001",
            "date-format": "mm/dd/yy"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "service_end_date" }, [
            _createTextVNode(" Service End Date "),
            _createElementVNode("span", { class: "sub-text" }, "(no documenting events of this discipline after: )")
          ], -1)),
          _createVNode(_unref(Calendar), {
            id: "service_end_date",
            modelValue: serviceEndDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((serviceEndDate).value = $event)),
            class: "w-full",
            placeholder: "01/01/2001",
            "date-format": "mm/dd/yy"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (endDate.value && serviceEndDate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              name: "warning",
              class: "confirm-dialog-icon text-gray-600"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _cache[4] || (_cache[4] = _createTextVNode(" Removing ", -1)),
                _createElementVNode("b", null, _toDisplayString(_unref(discipline).name), 1),
                _cache[5] || (_cache[5] = _createTextVNode(" from this contract will remove ", -1)),
                _createElementVNode("b", null, _toDisplayString(eventsRemoved.value), 1),
                _cache[6] || (_cache[6] = _createTextVNode(" events scheduled after ", -1)),
                _createElementVNode("b", null, _toDisplayString(Intl.DateTimeFormat().format(endDate.value)), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" and will prevent new events with this discipline from being created after this date. ", -1))
              ]),
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(serviceProvidersCount.value), 1),
                _cache[8] || (_cache[8] = _createTextVNode(" Service Providers will have until ", -1)),
                _createElementVNode("b", null, _toDisplayString(Intl.DateTimeFormat().format(serviceEndDate.value)), 1),
                _cache[9] || (_cache[9] = _createTextVNode(" to create or document any events of this discipline. ", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})